import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-filter-modal-od-do',
  templateUrl: './filter-modal-od-do.component.html',
  styleUrls: ['./filter-modal-od-do.component.scss'],
  standalone: false
})
export class FilterModalOdDoComponent implements OnInit {
  @Input() updateInputValue = new EventEmitter();
  context = localStorage.getItem('userContext');
  parsedContext = JSON.parse(this.context);
  reportForm: UntypedFormGroup;

  constructor(private bsModalRef: BsModalRef) { }

  ngOnInit(): void { }

  onSubmit() {
    if (this.reportForm.valid) {
      this.updateInputValue.emit(this.reportForm.value);
      this.closeModal();
    } else {
      this.reportForm.markAllAsTouched();
    }
  }
  closeModal() {
    this.bsModalRef.hide();
  }

}
